import React, {useCallback, useContext, useMemo} from 'react'
import {DialogContext} from './dialog-context'
export {DialogProvider} from './dialog-provider'

const defaultConfig = {}

export const useDialog = (initialConfig = defaultConfig) => {
    const context = useContext(DialogContext)
    if (!context) throw new Error('useDialog must be used inside DialogProvider')
    const {open: openDialog, close: closeDialog} = context

    const closeRef = React.useRef(null)
    const close = useCallback(() => {
        if (closeRef.current) closeDialog(closeRef.current)
        closeRef.current = null
    }, [closeDialog])

    const getConfig = useCallback((config = {}) => {
        if (typeof initialConfig === 'function') return initialConfig(config) || {}
        return {...initialConfig, ...config}
    }, [initialConfig])

    const open = useCallback((config = {}) => {
        const id = openDialog(getConfig(config))
        closeRef.current = id
        return id
    }, [getConfig, openDialog])

    return useMemo(() => ({open, close}), [close, open])
}
